import {administrativoApi} from "../view/administrativo.service";
import {buildFiltersUrl, reshape_response} from "../../../../helpers/functions";


export const getAdministrativos = administrativoApi.injectEndpoints({
    endpoints: (builder) => ({
        getAdministrativos: builder.query({
            query: ({filter_params}) => ({
                url: buildFiltersUrl("/v1/api/no_docente/", filter_params),
                method: "GET",
            }),
            providesTags: (result) =>
                Array.isArray(result)
                    ? [
                        ...result.map(({id}) => ({
                            type: "Administrativo",
                            id,
                        })),
                        {type: "Administrativo", id: "LIST"},
                    ]
                    : [{type: "Administrativo", id: "LIST"}],
            transformResponse: (response, meta, args) => {
                if (Array.isArray(response)) {
                    return response?.map((el) => reshape_response(el, args?.shape));
                } else {
                    const resultsTransformed = response?.results?.map((el) =>
                        reshape_response(el, args?.shape)
                    );

                    // Devolvemos los resultados transformados junto con las propiedades de paginación
                    return {
                        results: resultsTransformed,
                        count: response.count,
                        next: response.next,
                        previous: response.previous,
                    };
                }
            },
        }),
    }),
})

export const {
    useGetAdministrativosQuery,
} = getAdministrativos;